/* eslint-disable no-underscore-dangle */
import { isEmpty, map } from 'lodash';

import methodPromise from './method-promise-wrapper';

const EXPRESION_NEGATIVE = /{-y}/;
const REGEX = new RegExp(EXPRESION_NEGATIVE);
const TEMPLATE_RE = /\{ *([\w_-]+) *\}/g;

/**
 * Fetch the MapBox stored in the URL and get the layer names.
 *
 * @async
 * @param {string} url - The URL where the MapBox is stored.
 * @param {object} [layerTileParams] - An object with the layer position.
 * @returns {string[]} An array with the layer names.
 * @throws {Error} If something goes wrong.
 */
const loadMapBoxLayerNames = async (url, layerTileParams = {}) => {
  let tileParams = { x: 0, z: 0 };
  if (url.match(REGEX)) tileParams['-y'] = 0;
  else tileParams.y = 0;
  if (!isEmpty(layerTileParams)) tileParams = { ...layerTileParams };
  const tileUrl = `MVT:${url.replace(TEMPLATE_RE, (match, key) => tileParams[key])}`;
  try {
    const mapbox = await methodPromise('layers.loadOGRGeoJSON', {
      url: tileUrl,
      layerName: null,
      attribute: null
    });
    return map(mapbox.layers, ({ name }) => name);
  } catch (err) {
    throw new Error(err.message);
  }
};

export default loadMapBoxLayerNames;
